import { useState, useEffect } from 'react';
import Header from './Header';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [isSticky, setIsSticky] = useState(false);

  // Listen for scroll events and toggle sticky header
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="relative isolate overflow-hidden pt-14">
      {/* Hero background image */}
      <img
        src="./assets/images/hero.jpg"
        alt=""
        className="absolute inset-0 -z-10 h-full w-full object-cover"
      />
      {/* Hero content */}
      <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
        <div className="hidden sm:mb-8 sm:flex sm:justify-center">
          <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-300 ring-1 ring-white/10 hover:ring-white/20">
            تصویرسازی خود را سبک‌تر کنید{' '}
            <a href="#" className="font-semibold text-white">
              <span className="absolute inset-0" aria-hidden="true" />
              اطلاعات بیشتر <span aria-hidden="true">&larr;</span>
            </a>
          </div>
        </div>
        <div className="text-center">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
            X5 با هدف ارائه تصویربرداری سونوگرافی در فضا
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-700">
            تحول بازار اولتراسوند با سیستم سونوگرافی داپلر رنگی طراحی شده به سبک لپ تاپ
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="#"
              className="rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400"
            >
              شروع کنید
            </a>
            <a href="#" className="text-sm font-semibold leading-6 text-white">
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
